






export default {
  name: 'laurels'

  data: ->
    laurels: [
      require '@/assets/images/laurels/geotap-game-indie-corner-feature.png'
      require '@/assets/images/laurels/geotap-game-indie-prize-finalist.png'
      require '@/assets/images/laurels/geotap-game-play-store-feature.png'
    ]
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Laurels.vue